/**
 * Get a data URL from a file object.
 */
export default (blob => new Promise((resolve, reject) => {
  const reader = new FileReader();
  reader.onload = async () => {
    const {
      result
    } = reader;
    const removeExifData = (await import('piexifjs')).remove;

    // used to remove potentially sensitive metadata from images
    if (result.includes('jpeg')) {
      return resolve(removeExifData(result));
    }
    return resolve(result);
  };
  reader.onerror = () => {
    reject();
  };
  reader.readAsDataURL(blob);
}));